import { IAppState } from '../../store';

export const selectObjectType = (state: IAppState) => state.personalLeadsForm.data.objectType;
